/** @jsx jsx */
import { jsx } from '@emotion/react';

import { isUndefined } from 'lodash';

import type { TrackingData } from 'js/lib/retracked';
import { get } from 'js/lib/user';

import SkillCard, {
  SkillCardPlaceholder,
} from 'bundles/enterprise-legacy-learner-home/components/myLearning/skillsDashboard/SkillCard';
import useUserSkillScores from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/hooks/useUserSkillScores';
import type {
  PropsFromCaller,
  PropsFromSkillScoreGraphql,
} from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/withSkillScore';

type PropsFromParent = {
  className?: string;
  skillId: string;
  skillName: string;
  trackingData: TrackingData;
  programSlug: string;
  currentRefinement: string | undefined;
};
type Props = PropsFromParent & PropsFromCaller & PropsFromSkillScoreGraphql;

const SkillCardWithScore = ({ className, skillId, skillName, trackingData, programSlug, currentRefinement }: Props) => {
  const { isLoadingScore, skillScores } = useUserSkillScores({ skillIds: [skillId], userId: get()?.id });
  const skillScore = skillScores[skillId];

  if (isLoadingScore) {
    return <SkillCardPlaceholder className={className} />;
  } else {
    return (
      <SkillCard
        size="small"
        className={className}
        skill={{
          skillId,
          skillName,
          score: skillScore ?? 0,
          isEligibleForScoring: !isUndefined(skillScore),
          // This are all hardcoded default values, unnecesary for the search banner
          domains: [],
          scoredAtTime: 0,
          levelsetStatus: 'UNAVAILABLE',
        }}
        currentRefinement={currentRefinement}
        trackingData={trackingData}
        trackingName="search_banner_skill_card"
        source="search_banner_skill_card"
        programSlug={programSlug}
      />
    );
  }
};

export default SkillCardWithScore;
